module.exports = __webpack_public_path__ + "static/img/forest-poster-mobile.9071098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/forest-poster-mobile.jpg
// module id = dtMk
// module chunks = 1